import { baseStoreCreator } from '@/utils/store';

export interface EligibleServicesPayload {
  eligibleServicesIds: string[];
}

export const DEFAULT_VALUES: EligibleServicesPayload = {
  eligibleServicesIds: [],
};

export const useStore = baseStoreCreator<EligibleServicesPayload>(DEFAULT_VALUES);

export default useStore;
